/**
 * Blockchain event names
 * Centralized enum to avoid hardcoded strings and typos
 */
export enum BlockchainEvent {
  // Market events
  CREATED_MARKET = 'CreatedMarket',
  SETTLED_MARKET = 'SettledMarket',
  PLACED_PREDICTION = 'PlacedPrediction',
  CANCELLED_MARKET = 'CancelledMarket',

  // Creator events
  CREATED_CREATOR = 'CreatedCreator',
  UPDATED_CREATOR = 'UpdatedCreator',

  // ERC20 Token events
  APPROVAL = 'Approval',
  TRANSFER = 'Transfer',
}
